function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.967 17.117c-.004-.01 0-.02-.004-.03l-.007-.02c-.003-.005-.004-.01-.006-.017l-2.487-6.63c-.128-.342-.492-.51-.812-.371-.321.137-.476.525-.347.866l1.629 4.342c-3.466-2.594-7.795-3.923-12.929-3.923-6.099 0-11.079 1.853-14.802 5.508a.7.7 0 00-.037.943c.234.272.63.288.884.038 3.485-3.422 8.18-5.156 13.955-5.156 5.082 0 9.325 1.345 12.645 4h-5.143c-.345 0-.625.298-.625.666 0 .368.28.666.625.666h6.877a.6.6 0 00.271-.072c.028-.014.048-.036.073-.054.04-.028.082-.05.116-.088.014-.015.018-.035.029-.051.008-.01.02-.015.027-.027.012-.017.01-.038.02-.056a.667.667 0 00.067-.197c.005-.03.011-.056.012-.085a.662.662 0 00-.03-.252z",
  fill: "currentColor"
})));